"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    actions: Array,
    animation: Boolean | Object,
    buttonLayout: String,
    closable: Boolean,
    content: String,
    height: Number | String,
    maxHeight: Number,
    maxWidth: Number,
    messages: Object,
    minHeight: Number,
    minWidth: Number,
    modal: Boolean | Object,
    title: String | Boolean,
    visible: Boolean,
    width: Number | String,
    size: String,

    // Events
    close: Function,
    hide: Function,
    initOpen: Function,
    open: Function,
    show: Function
};